import styled from 'styled-components';

export const FolderViewWrapper = styled.div`
  tbody tr {
    cursor: pointer;
    &:hover td {
      background: light-dark(var(--moon-100), var(--moon-850));
    }
  }
`;
